import { render } from "./home.vue?vue&type=template&id=d2bf905a&scoped=true&ts=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"

import "./home.vue?vue&type=style&index=0&id=d2bf905a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2bf905a"]])

export default __exports__